import { CardActionArea, CardContent } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import defaultInboxImage from 'theSource/assets/Inbox/defaultInboxImage.jpg';
import {
  CardMediaStyled,
  CardStyled,
  CardTextStyled,
  SwiperSlideStyled,
} from './MessageSlideStyled';
import { ROUTES } from 'theSource/app/routes';

export interface MessageSlideProps {
  id: number;
  text: string;
  imgUrl: string;
}

export const MessageSlide = ({ id, imgUrl, text }: MessageSlideProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation('pages.home');

  const handleCardClick = () => navigate(`${ROUTES.main.inbox.path}/${id}`);

  return (
    <SwiperSlideStyled data-testid="message-slide">
      <CardStyled>
        <CardActionArea onClick={handleCardClick}>
          <CardMediaStyled
            component="img"
            image={imgUrl === '' ? defaultInboxImage : imgUrl}
            alt={t('messageBackground')}
          />
          <CardContent data-testid="message-slide-body">
            <CardTextStyled variant="body2">{text}</CardTextStyled>
          </CardContent>
        </CardActionArea>
      </CardStyled>
    </SwiperSlideStyled>
  );
};

MessageSlide.displayName = 'SwiperSlide';
